import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerDropdownResult, EmployeeDropdownResult, GetCustomersInput, GetProjectsInput, GetStartProjectDetailsInput, ProjectResult, ProjectStatus, Result, ResultList, SecurityLevelEnum, SortOrder, StartProjectDetailListResult, StartProjectDetailListSortType, StartProjectDetailResult, StartProjectInput, TableHeader } from 'app/models';
import { CustomerService, EmployeeService, ProjectService, StartProjectDetailService, StartProjectService } from 'app/services';
import { Utility } from 'app/shared';

@Component({
  selector: 'app-project-detail-list',
  templateUrl: './project-detail-list.component.html',
  styleUrls: ['./project-detail-list.component.scss']
})
export class ProjectDetailListComponent implements OnInit {
  public result: Result = new Result();
  public isBusy: boolean;

  public token = '';
  public utility = Utility;
  public updateProjectId: number = 0;
  public sortOrder = SortOrder;
  public projectStatus = ProjectStatus;
  public newAssignedEmployeeId: number | null = 0;
  public newStatusId: number = 0;
  public tableHeaders: Array<TableHeader<StartProjectDetailListSortType>>;
  public newProjectId: number = 0;
  public customerId: number = 0;
  public assignedEmployeeId: number = 0;

  public projectResultList = new Array<ProjectResult>();
  public customerListForProject = new Array<CustomerDropdownResult>();
  public customerList = new Array<CustomerDropdownResult>();
  public employeeDropdown = new Array<EmployeeDropdownResult>();
  public getStartProjectDetailsInput = new GetStartProjectDetailsInput();
  public startProjectDetailListResult = new ResultList<StartProjectDetailListResult>();
  public startProjectDetail: StartProjectDetailResult | null = null;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private projectService: ProjectService,
    private customerService: CustomerService,
    private startProjectDetailService: StartProjectDetailService,
    private _coreSidebarService: CoreSidebarService,
    private startProjectService: StartProjectService,
    private modalService: NgbModal,
    private employeeService: EmployeeService
  ) {
    this.isBusy = false;

    this.result = new Result();
    this.tableHeaders = new Array<TableHeader<StartProjectDetailListSortType>>();

    this.tableHeaders.push(
      new TableHeader(StartProjectDetailListSortType.Id, 'Id', true),
      new TableHeader(StartProjectDetailListSortType.AssignedEmployeeFullName, 'AssignedEmployee', true),
      new TableHeader(StartProjectDetailListSortType.Title, 'Title', true),
      new TableHeader(StartProjectDetailListSortType.ProjectStatus, 'Status', true),
      new TableHeader(StartProjectDetailListSortType.CustomerName, 'CustomerName', true),
      new TableHeader(StartProjectDetailListSortType.ProjectName, 'Project', true),
      new TableHeader(StartProjectDetailListSortType.ProjectName, 'Action', true)
    );
  }

  ngOnInit(): void {
    this.token = Utility.getTokenType();
    this.employeeService.checkPermission().then(permissionResult => {
      if (permissionResult.success !== true)
        this.router.navigate(['../login'], { relativeTo: this.activatedRoute });
      else {
        if (this.token === 'dashboardToken') {
          this.loadEmployees();
          this.loadCustomersForProject();
          this.loadCustomers();
        }
        this.loadData();
      }
    }).catch(() => {
      this.router.navigate(['../login'], { relativeTo: this.activatedRoute });
    });
  }

  public projectSubmit(): void {
      this.projectAdd();
  }

  private projectAdd(): void {
    if (this.isBusy === false) {
      this.isBusy = true;
      const startProjectInput: StartProjectInput = {
        assignedEmployeeId: 0,
        // assignedEmployeeId: this.assignedEmployeeId ?? 0,
        customerProjectId: this.newProjectId ?? 0
      };
      this.startProjectService.addStartProject(startProjectInput).then(
        result => {
          this.isBusy = false;
          this.result = result;
          if (this.result.success === true) {
            this.result.message = Utility.AddOperationMessage;
            this.loadData();
          }
        }).catch(() => {
          this.isBusy = false;
        });
    }
  }

  public openModal(modalDanger: any, item: StartProjectDetailListResult): void {
    this.updateProjectId = item.id;
    this.newStatusId = item.projectStatus;
    this.newAssignedEmployeeId = item.assignedEmployeeId;
    this.modalService.open(modalDanger, {
      centered: true,
      windowClass: 'modal modal-danger'
    });
  }

  public updateProject() {
    this.startProjectDetailService.updateProjectStatus(this.updateProjectId, this.newStatusId).then(result => {
      if (result.success === true) {
        this.result = result;
        this.modalService.dismissAll();
        this.loadData();
      } else {
        this.result = result;
      }
    }).finally(() => {
      this.isBusy = false;
    });
    this.startProjectDetailService.updateAssignee(this.updateProjectId, (this.newAssignedEmployeeId == null) ? 0 : this.newAssignedEmployeeId).then(result => {
      if (result.success === true) {
        this.result = result;
        this.modalService.dismissAll();
        this.loadData();
      } else {
        this.result = result;
      }
    }).finally(() => {
      this.isBusy = false;
    });


  }

  public loadData(): void {
    if (this.isBusy === false) {
      this.isBusy = true;
      this.startProjectDetailService.getStartProjectDetailList(this.getStartProjectDetailsInput, this.token).then(result => {
        if (result.success === true) {
          this.startProjectDetailListResult = result;
        } else {
          this.result = result;
        }
      }).finally(() => {
        this.isBusy = false;
      });
    }
  }

  public submit(): void {
      this.add();
  }

  public deneme():void{
    console.log("yeni proje Id : " + this.newProjectId);
  }

  private add(): void {
    if (this.isBusy === false) {
      this.isBusy = true;
      const startProjectInput: StartProjectInput = {
        assignedEmployeeId: this.assignedEmployeeId ?? 0,
        customerProjectId: this.newProjectId ?? 0
      };
      this.startProjectService.addStartProject(startProjectInput).then(
        result => {
          this.isBusy = false;
          this.result = result;
          if (this.result.success === true) {
            this.result.message = Utility.AddOperationMessage;
            this.loadData();
          }
        }).catch(() => {
          this.isBusy = false;
        });
    }
  }

  public getProjectsWithCustomerId(): void {
    this.getStartProjectDetailsInput.projectId = null;
    this.projectResultList = new Array<ProjectResult>();
    if (this.getStartProjectDetailsInput.customerId !== null) {
      this.projectService.getProjectsWithCustomerId(this.getStartProjectDetailsInput.customerId ?? 0, this.token)
        .then(result => {
          if (result.success == true) {
            this.projectResultList = result.data;
          } else {
            this.result = result;
          }
        });
    }
  }

  private loadCustomersForProject(): void {
    const getCustomersInput = new GetCustomersInput();
    getCustomersInput.paginationInformation.currentPage = 0;
    this.customerService.getCustomerForProject()
      .then(result => {
        if (result.success == true) {
          this.customerListForProject = result.data;
        } else {
          this.result = result;
        }
      });
  }
  private loadCustomers(): void {
    const getCustomersInput = new GetCustomersInput();
    getCustomersInput.paginationInformation.currentPage = 0;
    this.customerService.getCustomers(getCustomersInput)
      .then(result => {
        if (result.success == true) {
          this.customerList = result.data;
        } else {
          this.result = result;
        }
      });
  }

  public modalOpenVC(modalVC: any): void {
    this.modalService.open(modalVC, {
      centered: true,
      windowClass: 'modal'
    });
  }

  private loadEmployees(): void {
    this.employeeService.getEmployeeDropdown()
      .then(result => {
        if (result.success == true) {
          this.employeeDropdown = result.data;
        } else {
          this.result = result;
        }
      });
  }

  public onPageChange(currentPage: number): void {
    if (this.isBusy === false) {
      this.getStartProjectDetailsInput.paginationInformation.currentPage = currentPage;
      this.loadData();
    }
  }



  public onSortChange(sortType: StartProjectDetailListSortType): void {
    if (this.isBusy === false) {
      if (this.getStartProjectDetailsInput.sortOrder === SortOrder.Ascending)
        this.getStartProjectDetailsInput.sortOrder = SortOrder.Descending;
      else
        this.getStartProjectDetailsInput.sortOrder = SortOrder.Ascending;
      this.getStartProjectDetailsInput.sortType = sortType;
      this.loadData();
    }
  }

  public downloadExcel(): void {
    this.startProjectDetailService.getStartProjectDetailListExportToExcel(this.getStartProjectDetailsInput).then(result => {
      if (result.success === false) {
        this.result = result;
      }
      else {
        Utility.convertAndDownloadExcel(result.data.toString());
      }
    });
  }
}
